module.exports = __webpack_public_path__ + "static/media/SWAP.8e196be8.png";